import styled from 'styled-components/macro';

export const ConversationBox = styled.div`
  display: flex;
`;
